module.exports = __webpack_public_path__ + "f4641224a35ce5c73e61465b6a848770.svg";